import styled from 'styled-components';

const PageWrapper = styled.div<{isMobile: boolean}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${(p) => (p.isMobile ? '20px' : '140px 0 0 0')};
  height: 100vh;
  text-align: center;
  font-family: 'Roboto', sans-serif;
`;

const PageTitle = styled.h1`
  font-size: 72px;
  font-weight: bold;
  color: ${(p) => p.theme.colors.primary500};
  margin-bottom: 60px;
`;

const PageDescription = styled.p`
  font-size: 20px;
  line-height: 35px;
  color: ${(p) => p.theme.colors.gray400};
`;

export { PageWrapper, PageTitle, PageDescription };